// Tenant notifications API — used by the super-admin notification bell
// and the /super/alerts page. Platform admins (super_admin / admin) get
// system-scope rows (organisationId IS NULL — ENGINE_HEALTH, etc.) plus
// any org-scoped rows for the org they belong to. The backend handles
// that scoping; the UI just consumes the array.
//
// Endpoint shape:
//   GET    /api/user/v1/notification           -> Notification[]
//   GET    /api/user/v1/notification/:id       -> Notification
//   PATCH  /api/user/v1/notification/mark_read/:id   -> { msg }
//   PATCH  /api/user/v1/notification/mark_read       -> { msg }
//
// Notification: { id, title, content, type, created, read }

import api from "../utils/axios/v1/userAxios";

export const getNotifications = (params) =>
  api.get("/notification", params ? { params } : undefined);

export const getNotification = (id) =>
  api.get(`/notification/${encodeURIComponent(id)}`);

export const markRead = (id) =>
  api.patch(`/notification/mark_read/${encodeURIComponent(id)}`);

export const markAllRead = () => api.patch("/notification/mark_read");
